import {Button, Dialog, DialogContent, CircularProgress} from "@mui/material";
import './styless.scss'
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, RootState} from "../../store";
import {setOpenDropDialogChange, fetchMemberInfoAsync} from "../../store/memberSlice";
import CloseIcon from "@mui/icons-material/Close";
import droplet from "../../assets/droplet.png";
import darkDroplet from "../../assets/darkDroplet.png";
import {WechatIcon} from "../../icons";
import { useState, useEffect, useMemo, useRef } from "react";
import {useTranslation} from "react-i18next";
import {createProductOrder, getQrcode, getProductRechargeRecords, WaterdropProductItem} from "../../api/payment";
import {useMatomoTrackingPoint} from "../../hooks/useMatomoTrackingPoint";
import {useCountdown} from "../../hooks/useCountdown";
import sold from '../../assets/sold.png'
import newMember from '../../assets/newMember.png'

export default function WaterDropBag (props: {handleSelectPaymentOpen: (open: boolean) => void, handleCallBackPlan: (plan: {plan: string, amount: number, dropAmount?: number}) => void}) {

    const { handleSelectPaymentOpen, handleCallBackPlan } = props;
    const openDropDialog = true; // useSelector((state: RootState) => state.member.openDropDialog);
    const productsList = useSelector((state: RootState) => state.waterdrop.products);
    const loading = useSelector((state: RootState) => state.waterdrop.loading);
    const [selectedItem, setSelectedItem] = useState<number>(0);
    const [paymentSuccess, setPaymentSuccess] = useState(false)
    const [qrCode, setQrCode] = useState<string>('');
    const [qrCodeLoading, setQrCodeLoading] = useState(false);
    const lastProductIdRef = useRef<number | null>(null);
    const pollingRef = useRef<NodeJS.Timeout | null>(null);
    const currentOrderNoRef = useRef<string | null>(null);
    const dialogOpenTimeRef = useRef<number | null>(null);
    const memberInfo = useSelector((state: RootState) => state.member.memberInfo);
    
    // 检查是否有新人产品
    const hasNewUserProduct = useMemo(() => {
        return productsList.some(item => item.new_user_only === 1);
    }, [productsList]);
    
    // 使用倒计时 hook
    const countdown = useCountdown({
        startTime: memberInfo?.createAt,
        durationDays: 3,
        enabled: hasNewUserProduct && !!memberInfo?.createAt
    });

    const {trackWaterdropPackageChoose, trackWaterdropPackagePopupShowTime, trackBillingPopupShowTime} = useMatomoTrackingPoint()

    const dispatch: AppDispatch = useDispatch()

    const handleItemClick = (index: number) => {
        const product = productsList[index];
        if (product && product.is_active === 1) {
            const page_id = window.location.href;
            trackWaterdropPackageChoose({waterdrop_amount: product.points_amount, page_id, subscription_plan: product.description})
            setSelectedItem(index);
        }
    }

    const { t } = useTranslation()

    // 停止轮询
    const stopPolling = () => {
        if (pollingRef.current) {
            clearInterval(pollingRef.current);
            pollingRef.current = null;
        }
        currentOrderNoRef.current = null;
    };

    // 检查订单状态
    const checkOrderStatus = async (out_trade_no: string) => {
        try {
            const response = await getProductRechargeRecords(out_trade_no);
            if (response && response.points_status === 'Success') {
                stopPolling();
                setPaymentSuccess(true);
                dispatch(fetchMemberInfoAsync());
                dispatch(setOpenDropDialogChange(false));
            } else if (response && response.points_status === 'Failed') {
                stopPolling();
            }
        } catch (error) {
            console.error('检查订单状态失败:', error);
        }
    };

    useEffect(() => {
        if (openDropDialog) {
            dialogOpenTimeRef.current = Date.now();
        } else if (dialogOpenTimeRef.current) {
            const duration = Date.now() - dialogOpenTimeRef.current;
            const page_id = window.location.href;
            trackWaterdropPackagePopupShowTime({show_time: duration, page_id})
            dialogOpenTimeRef.current = null;
        }
    }, [openDropDialog]);

    useEffect(() => {
        if (!openDropDialog) {
            stopPolling();
            setQrCode('');
            setQrCodeLoading(false);
            lastProductIdRef.current = null;
        }
        return () => {
            stopPolling();
        };
    }, [openDropDialog]);

    // 确保选中的商品是有效的且可用的
    const selectedProduct = useMemo(() => {
        const product = productsList[selectedItem] && productsList[selectedItem].is_active === 1
            ? productsList[selectedItem]
            : productsList.find(p => p.is_active === 1) || null;
        return product;
    }, [productsList, selectedItem]);

    // 获取二维码
    const fetchQrCode = async (product: WaterdropProductItem) => {
        if (!product || product.is_active !== 1) return;
        
        // 先停止之前的轮询
        stopPolling();
        
        setQrCodeLoading(true);
        setQrCode('');
        
        try {
            const now = new Date();
            const expireTime = new Date(now.getTime() + 15 * 60 * 1000); // 15min
            const timeExpire = expireTime.toISOString().replace('Z', '+08:00');
            
            const orderData = await createProductOrder(product.product_id, timeExpire);
            if (orderData && orderData.data.qr_code) {
                const qrCodeData = await getQrcode(orderData.data.qr_code);
                if (qrCodeData?.qrCode) {
                    setQrCode(qrCodeData.qrCode);
                    // 保存订单号并开始轮询
                    currentOrderNoRef.current = orderData.data.out_trade_no;
                    pollingRef.current = setInterval(() => {
                        if (currentOrderNoRef.current) {
                            checkOrderStatus(currentOrderNoRef.current);
                        }
                    }, 1000);
                }
            }
        } catch (error) {
            console.error('获取二维码失败:', error);
        } finally {
            setQrCodeLoading(false);
        }
    };

    // 当选中商品变化时，获取二维码
/*    useEffect(() => {
        if (openDropDialog && selectedProduct) {
            const currentProductId = selectedProduct.id;
            if (currentProductId !== lastProductIdRef.current) {
                lastProductIdRef.current = currentProductId;
                fetchQrCode(selectedProduct);
            }
        }
    }, [selectedProduct, openDropDialog]);*/


    return <div>
        <Dialog
            open={paymentSuccess}
            onClose={() => {
                setPaymentSuccess(false)
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: 'none',
                    borderRadius: "20px"
                },
                '& .MuiDialogContent-root': {
                    padding: '0',
                }
            }}
        >
            <DialogContent>
                <div className='check-box'>
                    <p className="check-box-text">
                        {t('payment_success_price', {amount: selectedProduct?.price ? selectedProduct.price / 100 : 0})}
                    </p>
                    <div className="check-box-actions">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setPaymentSuccess(false)
                            }}
                            sx={{
                                minWidth: '100px',
                                textTransform: 'none',
                                fontWeight: 500
                            }}
                        >
                            {t('confirm')}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
        <div className="waterDropBagContainer">
            <div className="waterDropBagTipsContainer">
                {loading ? (
                    <div className="water-drop-placeholder">加载中...</div>
                ) : productsList.length > 0 ? (
                    productsList.filter(p => p.product_type === 'waterdrop').map((product, index) => {
                        const isSoldOut = product.is_active !== 1;
                        const isSelected = selectedItem === index && !isSoldOut;
                        const isDiscount = product.original_price_discount;
                        return (
                            <div
                                key={product.id}
                                className={`waterDropBagItem ${isSelected ? 'waterDropBagItemSelected' : ''}`}
                                onClick={() => !isSoldOut && handleItemClick(index)}
                                style={isSoldOut ? {
                                    backgroundColor: 'var(--c-border-light)',
                                    color: 'var(--c-text-secondary)',
                                    cursor: 'not-allowed',
                                    position: 'relative',
                                    display: ((!countdown || memberInfo?.isBuyLimitDay) && product.new_user_only === 1) ? 'none' : 'block'
                                } : {position: 'relative', display: ((!countdown || memberInfo?.isBuyLimitDay)  && product.new_user_only === 1) ? 'none' : 'block'}}
                            >
                                {product.new_user_only === 1 && countdown && <><img src={newMember} alt='' className="new-member-badge"/>
                                    <div className='countDown'>
                                        <>距结束 <span>{String(countdown?.days).padStart(2, '0')}</span>天 <span>{String(countdown?.hours).padStart(2, '0')}</span>:<span>{String(countdown?.minutes).padStart(2, '0')}</span>:<span>{String(countdown?.seconds).padStart(2, '0')}</span></>
                                    </div>
                                </>}
                                {isSoldOut &&
                                    <img src={sold} alt='' className="sold-badge"/>}
                                <div className="waterDropBagItemContent" style={{backgroundColor: isSoldOut ? 'var(--c-border)' : 'var(--c-bg-tertiary)'}}>
                                    <img className="water-drop-icon" src={isSoldOut ? darkDroplet : droplet} alt='droplet'/>
                                    {product.points_amount}
                                    <span className="water-drop-type">
                                       {
                                           product.points_type === 'supply_drop' ? '补给水滴' : '永久水滴'
                                       }
                                    </span>
                                </div>
                                <div className='buttonStyles'>
                                    {
                                        isDiscount ?
                                            <div className="discount-group">
                                                <div className='waterDropBagItemDiscount'
                                                     style={isSoldOut ? {
                                                         color: 'var(--c-on-color)',
                                                         backgroundColor: 'var(--c-border)',
                                                         cursor: 'not-allowed'
                                                     } : {}}
                                                >
                                                    {product.original_price_discount}
                                                </div>
                                                <div className="waterDropBagItemPrice waterDropBagItemPrice--discount" style={{
                                                    lineHeight: '15px',
                                                    backgroundColor: isSoldOut ? '#999999' : '#444444'
                                                }}>
                                                    <div className="original-price-text">
                                                        ¥{(product.original_price! / 100).toFixed(2)}
                                                    </div>
                                                    <div>¥{(product.price / 100).toFixed(2)}</div>
                                                </div>
                                            </div>
                                        : <div className='priceItem'
                                               style={isSoldOut ? {
                                                   color: 'var(--c-on-color)',
                                                   backgroundColor: '#999999',
                                                   cursor: 'not-allowed'
                                               } : {}}
                                            >¥{(product.price / 100).toFixed(2)}</div>
                                    }
                                    <div className='quicklyBuy'
                                         onClick={()=>{
                                             if (isSoldOut) return;
                                             handleSelectPaymentOpen(true)
                                             handleCallBackPlan({
                                                 plan: product.product_id,
                                                 amount: (product.price / 100),
                                                 dropAmount: product.points_amount,
                                                 productId: product.product_id
                                             })
                                         }}
                                         style={isSoldOut ? {
                                             color: 'var(--c-text-secondary)',
                                             border: '1px solid var(--c-text-secondary)',
                                             cursor: 'not-allowed'
                                         } : {}}
                                    >{product.new_user_only === 1 ? '立即购买（限购1件）' : '立即购买'}</div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="water-drop-placeholder">暂无产品</div>
                )}
            </div>
        </div>
    </div>
}